import { CheckCircle, Truck, Clock } from "lucide-react";

export default function BenefitsSection() {
  const benefits = [
    {
      icon: <CheckCircle className="h-8 w-8 text-[#D4AF37]" />,
      heading: "Pure Elegance Guaranteed",
      description: "Every fragrance is crafted with the finest ingredients for timeless luxury.",
    },
    {
      icon: <Truck className="h-8 w-8 text-[#D4AF37]" />,
      heading: "Seamless Luxury Delivery",
      description: "Enjoy complimentary shipping across India with every order.",
    },
    {
      icon: <Clock className="h-8 w-8 text-[#D4AF37]" />,
      heading: "Swift Scent Arrival",
      description: "Your order is dispatched within 24 hours, ready to delight.",
    },
  ];

  return (
    <>
      {/* Inline CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeInUp {
            animation: fadeInUp 1s ease-out forwards;
          }
        `}
      </style>

      <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center animate-fadeInUp"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="mb-4">{benefit.icon}</div>
              <h3
                className="text-lg md:text-xl text-[#333333] mb-2"
                style={{ fontFamily: " serif" }}
              >
                {benefit.heading}
              </h3>
              {benefit.description && (
                <p className="text-sm text-gray-500 max-w-xs">
                  {benefit.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}